<template>
    <div class="panel panel-visible widget-client_subs">
        <div class="panel-heading">
            <div class="panel-title hidden-xs">
                <span class="glyphicon glyphicon-credit-card"></span>
                Клиентские карты
            </div>

        </div>
        <div class="panel-body">
            <table class="table table-striped table-hover client_cards">
                <thead>
                <tr>
                    <th> Номер карты</th>
                    <th> Дата выдачи</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(card, index) in client.cards" v-bind:key="index">
                    <td>{{card.number}}</td>
                    <td>{{card.createdAt | dateFormatTimestamp('dd.mm.yyyy')}}</td>
                </tr>
                <tr v-show="client.cards.length === 0">
                    <td colspan="2" class="text-center">Нет карты</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="panel-menu">
            <form v-on:submit.prevent="cardAdd">
                <div class="row">
                    <div class="col-md-7">
                        <input type="text" v-model.trim="forms.card.number" class="form-control" placeholder="№ карты" value="" autocomplete="off">
                        <div class="error" v-show="forms.card.number.length > 0 && forms.card.number.length !== 12"> Введите 12 цифр</div>
                    </div>
                    <div class="col-md-4">
                        <input :disabled="forms.card.number.length !== 12" type="submit" class="btn btn-primary mr10" value="Добавить">
                    </div>
                </div>
            </form>
        </div>

    </div>
</template>

<script>
    import Client from '../../models/Client';
    import ClientCard from "../../models/ClientCard";
    export default {
        props: {
            client: Client,
        },
        data() {
            return {

                forms: {
                    card: {
                        number: '',
                    },
                },
            };
        },
        methods: {
            async cardAdd() {
                this.isLoading = true;
                if (this.forms.card.number.length !== 12) {
                    return;
                }
                let newCard = new ClientCard();

                try {
                    newCard.clientId = this.client.id;
                    newCard.number = this.forms.card.number;

                    newCard = await newCard.add();

                } catch (error) {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка добавления карты',
                    });
                    return;
                }

                this.client.cards.push(newCard);
                this.forms.card.number = '';

                this.$notify({
                    text: 'Карта добавлена',
                });
                this.isLoading = false;
            },
        },
    }
</script>
